import { defineComponent as r } from "vue";
import e from "./index151.js";
import { MsArrowRight as t } from "@sunrise/icons";
const m = r({
  name: "CsNewsCard",
  components: { MsArrowRight: t, MsClickArea: e },
  props: {
    link: {
      type: Object,
      required: !0
    },
    trackingData: {
      type: Array,
      required: !1
    }
  }
});
export {
  m as default
};
